export const DISCOUNT_AMOUNT_DECIMALS = 4;

export const DISCOUNT_AMOUNT_ROUNDING_TOLERANCE = 1.5 * 10 ** -DISCOUNT_AMOUNT_DECIMALS;

export const PERCENTAGE_DISCOUNT_LIMIT = 100;
